import { Injectable, Inject } from '@angular/core';
import { TransferState } from '../modules/transfer-state/transfer-state';

@Injectable()
export class Config {
  _config:any = {};

  constructor(
    @Inject('isBrowser') isBrowser: boolean,
    private cache: TransferState
  ) {
    if (isBrowser) {
      this._config = cache.get('Config');
      this._config.SHARE_API_SERVICE = '/share/share-api';
    } else {
      this._config = {
        PUBLIC_PATH: process.env.PUBLIC_PATH || '/share/',
        BOX_URL: process.env.BOX_URL || 'http://localhost.ru',
        NIMBUS_DOMAIN: process.env.NIMBUS_DOMAIN || 'localhost.ru',
        SHARE_API_SERVICE: process.env.SHARE_API_SERVICE || "http://localhost.ru:8096/share/share-api",
        NIMBUS_URL: process.env.NIMBUS_URL || 'http://localhost.ru',
        NIMBUS_NOTE_URL: process.env.NIMBUS_NOTE_URL || 'http://localhost.ru/client',
        SERVER_SECURE: process.env.SERVER_SECURE || 1,
        SIGN_PUBLIC_KEY: process.env.SIGN_PUBLIC_KEY || 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApkh92m5XytQdag/4cqBxegK8F2Yopj+LivFhMfKQSsc5/dB/HA9m4wP7ohj6bkuzr02Uwmdtcxb2jiz5aTb+ikOnPremvNfyATQ2d663VHfpJZfFwamCy6bvLQpY1EkzEvTIsjGdAjl0HDdFKXalKa4KATIigf4wL2SG9getC8kNS0IsP4HFqAovvy0Mx6zY2LfIkm7onl0M2MF4D+YzmGLR/E3RRxrhdnIkPMCkt14TLX+7+ZaLS1yy87WFtyMtaJPpN26+vln0ui5XHIv2W1v4BaMwVHYIs4bnvEWM61JbnqlpJihzQhvW64yD55tEi9FL+JOze0jYrSk+IqMZ0wIDAQAB',
        SOCKET_EDITOR_DOMAIN_AND_PATH: process.env.SOCKET_EDITOR_DOMAIN_AND_PATH || 'text.dev-thefusebase.com/socket.io.editor',
        SOCKET_EDITOR_CONSTANT_DOMAIN: process.env.SOCKET_EDITOR_CONSTANT_DOMAIN || 1,
        SOCKET_EDITOR_PROTOCOL: process.env.SOCKET_EDITOR_PROTOCOL || 'wss://',
        SPAM_LINK: process.env.SPAM_LINK || 'https://nimbusweb.co/contact.php',
        SHORT_URL_SERVICE: process.env.SHORT_URL_SERVICE || '/short-url/',
        GTAG_ID: process.env.GTAG_ID || '',
        ALTERED_GTAG_ID: process.env.ALTERED_GTAG_ID || '',
        GTM_ID: process.env.GTM_ID || '',
        ADD_THIS_ID: process.env.ADD_THIS_ID || '',
        AUTH_HOST: process.env.AUTH_HOST || 'localhost.ru',
        AUTH_API_PATH: process.env.AUTH_API_PATH || '/share/auth-api',
        AUTH_LOGIN_PATH: process.env.AUTH_LOGIN_PATH || `/?f=login`,
        AUTH_LOGOUT_PATH: process.env.AUTH_LOGOUT_PATH || `/logout.php`,
        AUTH_OPENORG_PATH: process.env.AUTH_OPENORG_PATH || `/open-org`,
        NIMBUS_TEAMS_URL: process.env.NIMBUS_TEAMS_URL || 'http://localhost.ru',
        NIMBUS_UPGRADE_URL: process.env.NIMBUS_UPGRADE_URL || 'https://nimbusweb.me/pricing.php',
        NIMBUS_TERMS_URL: process.env.NIMBUS_TERMS_URL || 'https://nimbusweb.me/terms-and-conditions.php',
        NIMBUS_CONTACT_URL: process.env.NIMBUS_CONTACT_URL || 'https://nimbusweb.co/contact.php',
        AUTH_API_URL: process.env.AUTH_API_URL || '/auth/api',
        VIDEO_EDIT_URL: process.env.VIDEO_EDIT_URL || '/video-edit',
        GATEWAY_URL: process.env.GATEWAY_URL || '/gwapi2',
        DUMP_SERVER_URL: process.env.DUMP_SERVER_URL || '',
        FEATURES: process.env.FEATURES || '',
        N_ENV: process.env.N_ENV || 'dev',
        STATSD_PROXY: process.env.STATSD_PROXY || ''
      };
    }
  }

  get(key: string) {
    return this._config ?  this._config[key] : undefined;
  }

  getBrowserConfig() {
    const {
      BOX_URL,
      PUBLIC_PATH,
      SERVER_SECURE,
      SOCKET_EDITOR_DOMAIN_AND_PATH,
      SOCKET_EDITOR_CONSTANT_DOMAIN,
      SOCKET_EDITOR_PROTOCOL,
      NIMBUS_DOMAIN,
      NIMBUS_URL,
      NIMBUS_NOTE_URL,
      SPAM_LINK,
      SHORT_URL_SERVICE,
      GTAG_ID,
      ALTERED_GTAG_ID,
      GTM_ID,
      ADD_THIS_ID,
      AUTH_HOST,
      AUTH_API_PATH,
      AUTH_LOGIN_PATH,
      AUTH_LOGOUT_PATH,
      AUTH_OPENORG_PATH,
      NIMBUS_TEAMS_URL,
      NIMBUS_UPGRADE_URL,
      NIMBUS_TERMS_URL,
      NIMBUS_CONTACT_URL,
      AUTH_API_URL,
      VIDEO_EDIT_URL,
      GATEWAY_URL,
      SIGN_PUBLIC_KEY,
      DUMP_SERVER_URL,
      FEATURES,
      N_ENV,
      STATSD_PROXY
    } = this._config;

    return {
      BOX_URL,
      PUBLIC_PATH,
      SERVER_SECURE,
      SOCKET_EDITOR_DOMAIN_AND_PATH,
      SOCKET_EDITOR_CONSTANT_DOMAIN,
      SOCKET_EDITOR_PROTOCOL,
      NIMBUS_DOMAIN,
      NIMBUS_URL,
      NIMBUS_NOTE_URL,
      SPAM_LINK,
      SHORT_URL_SERVICE,
      GTAG_ID,
      ALTERED_GTAG_ID,
      GTM_ID,
      ADD_THIS_ID,
      AUTH_HOST,
      AUTH_API_PATH,
      AUTH_LOGIN_PATH,
      AUTH_LOGOUT_PATH,
      AUTH_OPENORG_PATH,
      NIMBUS_TEAMS_URL,
      NIMBUS_UPGRADE_URL,
      NIMBUS_TERMS_URL,
      NIMBUS_CONTACT_URL,
      AUTH_API_URL,
      VIDEO_EDIT_URL,
      GATEWAY_URL,
      SIGN_PUBLIC_KEY,
      DUMP_SERVER_URL,
      FEATURES,
      N_ENV,
      STATSD_PROXY
    };
  }
}
